import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import {
  DownloadButton,
  downloadReport
} from '../../elements/ReportDownload'
import SearchableSelect from 'app/src/elements/SearchableSelect';
import { sellerOptions } from './filterOptions';

import { cardStyles as styles } from './index';

const MissingTitlesBySellerReport = ({ data }) => {
  const [sellerId, setSellerId] = useState();

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'missing-titles-by-seller-report',
      params: { 'seller-id': sellerId }
    })
  }

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Missing Titles By Seller Report</Text>
      <Text style={styles.label}>Seller:</Text>
      <SearchableSelect
        placeholder="Select Seller"
        options={sellerOptions(data)}
        value={sellerId}
        onChange={setSellerId}
      />
      <DownloadButton handleDownload={handleDownload} />
    </View>
  )
};

export default MissingTitlesBySellerReport;
